export default "__VITE_ASSET__CkhOizKO__"